import { render, staticRenderFns } from "./FileListRecord.vue?vue&type=template&id=0c2e2b12&"
import script from "./FileListRecord.vue?vue&type=script&lang=js&"
export * from "./FileListRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports